import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ease-star-filled-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="tw-w-full tw-h-full" aria-hidden="true">
      <path
        d="M11.999 2.5l2.938 5.955 6.573.956-4.756 4.637 1.123 6.546L12 17.5l-5.878 3.094 1.123-6.546L2.489 9.41l6.573-.956L12 2.5z"
        fill="currentColor"
      />
    </svg>
  `,
  host: {
    class: 'tw-block tw-w-full tw-h-full',
  },
})
export class StarFilledIcon {}
